import { cva, type VariantProps } from "cva";

import styles from "./index.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    appearance: {
      default: "",
      text: styles.text,
    },
    widthType: {
      "fit-content": styles.fitContent,
      "over-container": styles.overContainer,
      "full-width": styles.fullWidth,
    },
    align: {
      center: styles.textCenter,
      left: styles.textLeft,
      right: styles.textRight,
    },
    fontSize: {
      xm: "",
      xxs: styles.fontSizeXxs,
    },
  },
  defaultVariants: {
    appearance: "default",
    align: "center",
    fontSize: "xm",
  },
});

export type LinkVariantProps = VariantProps<typeof variants>;
